import { Box, Grid } from 'components/ui';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { WhiteCard } from 'components/styles_components/card';
import { DividerContainer } from 'components/styles_components/container';
import {
  CardOptionDescriptionTypography,
  CardOptionTypography,
} from 'components/styles_components/typography';
import ProfileQuery from 'queries/user/profile';
import Boolean from 'components/boolean';
import PasswordChangeButton from 'components/user/profile/button/password_change';
import Disable2FaButton from 'components/user/profile/button/disable_two_factor';
import Enable2FaButton from 'components/user/profile/button/enable_two_factor';
import LoaderContainer from 'components/layout/loader_container';
import Date from 'components/date';
import { differenceInDays } from 'date-fns';

const Show = () => {
  const setError = useError();
  const {
    data = { user: {} },
    loading,
    refetch,
  } = useQuery(ProfileQuery, {
    onError: () => {
      setError('error.user.profile.show');
    },
  });
  const isPasswordOld =
    data.user.lastPasswordChangeAt &&
    differenceInDays(new window.Date(), new window.Date(data.user.lastPasswordChangeAt)) > 180;

  return (
    <LoaderContainer loading={loading} wrap={false}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <WhiteCard>
            <CardOptionTypography>
              <FormattedMessage id="user.security.two_factor" />
            </CardOptionTypography>
            <CardOptionDescriptionTypography>
              <FormattedMessage id="user.security.two_factor.description" />
            </CardOptionDescriptionTypography>
            <DividerContainer />
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Boolean
                value={data.user.otpEnabled}
                falseLabel={<FormattedMessage id="user.security.two_factor.active.no" />}
                trueLabel={<FormattedMessage id="user.security.two_factor.active.yes" />}
              />
              {data.user.otpEnabled ? (
                <Disable2FaButton refetch={refetch} />
              ) : (
                <Enable2FaButton refetch={refetch} />
              )}
            </Box>
          </WhiteCard>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <WhiteCard>
            <CardOptionTypography>
              <FormattedMessage id="user.security.change_password" />
            </CardOptionTypography>
            <CardOptionDescriptionTypography>
              <FormattedMessage id="user.security.change_password.description" />
            </CardOptionDescriptionTypography>
            <DividerContainer />
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <CardOptionDescriptionTypography>
                  <FormattedMessage id="user.security.change_password.last_password_change" />{' '}
                  <Date date={data.user.lastPasswordChangeAt} warning={isPasswordOld} />
                </CardOptionDescriptionTypography>
              </Box>

              <PasswordChangeButton user={data.user} refetch={refetch} />
            </Box>
          </WhiteCard>
        </Grid>
      </Grid>
    </LoaderContainer>
  );
};

export default Show;
